import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { cadastrarContaCliente, login, recuperarSenha, salvarSessaoAutenticacao } from '../../services/api';
import './Login.css';

const Login = ({
  modoInicial = 'login',
  permitirCadastro = true,
  apenasAdmin = false,
  tituloLogin = 'Entrar',
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [modo, setModo] = useState(modoInicial); // 'login' | 'cadastro' | 'recuperar'
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [mensagem, setMensagem] = useState(searchParams.get('erro') === 'acesso-negado' ? 'Acesso negado. Somente admin pode acessar o painel.' : '');
  const [tipoMensagem, setTipoMensagem] = useState(searchParams.get('erro') === 'acesso-negado' ? 'erro' : '');
  const [enviando, setEnviando] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setMensagem('');
    setTipoMensagem('');
    try {
      const dados = await login(email, senha);
      if (apenasAdmin && dados?.conta?.role !== 'admin') {
        setTipoMensagem('erro');
        setMensagem('Acesso negado. Este login e exclusivo para administradores.');
        return;
      }

      salvarSessaoAutenticacao(dados.token, dados.conta);

      navigate(dados?.conta?.role === 'admin' ? '/admin/home' : '/cliente/home');
    } catch (err) {
      setTipoMensagem('erro');
      setMensagem(err.message || 'Erro ao fazer login.');
    } finally {
      setEnviando(false);
    }
  };

  const handleCadastro = async (e) => {
    e.preventDefault();
    if (senha !== confirmarSenha) {
      setTipoMensagem('erro');
      setMensagem('As senhas não coincidem.');
      return;
    }
    setEnviando(true);
    setMensagem('');
    setTipoMensagem('');
    try {
      const dados = await cadastrarContaCliente(email, senha);
      salvarSessaoAutenticacao(dados.token, dados.conta);
      navigate('/cliente/home');
    } catch (err) {
      setTipoMensagem('erro');
      setMensagem(err.message || 'Erro ao cadastrar conta.');
    } finally {
      setEnviando(false);
    }
  };

  const handleRecuperarSenha = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setMensagem('');
    setTipoMensagem('');
    try {
      const resultado = await recuperarSenha(email);
      setTipoMensagem('sucesso');
      setMensagem(resultado.mensagem || 'Se existir uma conta com este email, voce recebera instrucoes para redefinir a senha.');
    } catch (err) {
      setTipoMensagem('erro');
      setMensagem(err.message || 'Erro ao solicitar recuperacao de senha.');
    } finally {
      setEnviando(false);
    }
  };

  const trocarModo = (novoModo) => {
    setModo(novoModo);
    setMensagem('');
    setTipoMensagem('');
    setEmail('');
    setSenha('');
    setConfirmarSenha('');
  };

  return (
    <div className="login-container ui-surface">
      <div className="login-tabs">
        <button
          className={`login-tab${modo === 'login' ? ' ativo' : ''}`}
          onClick={() => trocarModo('login')}
          type="button"
        >
          Entrar
        </button>
        {permitirCadastro && (
          <button
            className={`login-tab${modo === 'cadastro' ? ' ativo' : ''}`}
            onClick={() => trocarModo('cadastro')}
            type="button"
          >
            Criar Conta
          </button>
        )}
      </div>

      {modo === 'recuperar' ? (
        <form onSubmit={handleRecuperarSenha} className="login-form">
          <h2>Recuperar senha</h2>
          <p className="login-recuperar-texto">
            Informe o email da sua conta. Enviaremos um link para criar uma nova senha.
          </p>

          <label>Email:</label>
          <input
            className="ui-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button className="ui-button-primary" type="submit" disabled={enviando}>
            {enviando ? 'Enviando...' : 'Enviar link de recuperacao'}
          </button>

          <button
            className="login-voltar-link"
            type="button"
            onClick={() => trocarModo('login')}
          >
            Voltar para o login
          </button>
        </form>
      ) : modo === 'login' || !permitirCadastro ? (
        <form onSubmit={handleLogin} className="login-form">
          <h2>{tituloLogin}</h2>

          <label>Email:</label>
          <input
            className="ui-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Senha:</label>
          <input
            className="ui-input"
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />

          <button
            className="login-esqueci-senha"
            type="button"
            onClick={() => trocarModo('recuperar')}
          >
            Esqueci minha senha
          </button>

          <button className="ui-button-primary" type="submit" disabled={enviando}>
            {enviando ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      ) : permitirCadastro ? (
        <form onSubmit={handleCadastro} className="login-form">
          <h2>Criar Conta</h2>

          <label>Email:</label>
          <input
            className="ui-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Senha:</label>
          <input
            className="ui-input"
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />

          <label>Confirmar Senha:</label>
          <input
            className="ui-input"
            type="password"
            value={confirmarSenha}
            onChange={(e) => setConfirmarSenha(e.target.value)}
            required
          />

          <button className="ui-button-primary" type="submit" disabled={enviando}>
            {enviando ? 'Criando...' : 'Criar Conta'}
          </button>
        </form>
      ) : null}

      {mensagem && (
        <p className={`login-message${tipoMensagem === 'sucesso' ? ' login-message-sucesso' : ''}`}>
          {mensagem}
        </p>
      )}
    </div>
  );
};

export default Login;
